/**
 * Design sizes of the product demos, in a plain module (no 'use client') so
 * layouts can reserve space and server components can read the numbers
 * without importing the demos themselves. Every demo renders at exactly its
 * size and is scaled by FitScale.
 */
export const PHONE_SIZE = { width: 290, height: 600 } as const;

/** Phone plus the 32px brand pill and 16px gap above it. */
export const BRANDED_APP_DEMO_SIZE = { width: 290, height: 648 } as const;

/** Admin screens (calendar, CRM, enrollment), browser frame included. */
export const ADMIN_DEMO_SIZE = { width: 760, height: 480 } as const;

export const PAYMENTS_DEMO_SIZE = { width: 560, height: 440 } as const;

export const FEATURE_REQUEST_DEMO_SIZE = { width: 620, height: 400 } as const;
